import type { OpcaoEmpregado } from './catalogo-empregado.tipos'

export const empregadoNaoDesligado = (empregado: OpcaoEmpregado): boolean => !empregado.resignation
export const empregadoDesligado = (empregado: OpcaoEmpregado): boolean => Boolean(empregado.resignation)
export const empregadoPossuiBancoDeHoras = (empregado: OpcaoEmpregado): boolean => (
  Boolean(empregado.workHourBankRules || (typeof empregado.customRules === 'object' && empregado.customRules?.calculoPassivo))
)

export const obterDiaInicioFolha = (valor: unknown): number | null => {
  if (typeof valor !== 'number' || !Number.isInteger(valor)) return null
  if (valor >= 1 && valor <= 28) return valor
  const compacta = String(valor)
  if (compacta.length < 7 || compacta.length > 8) return null
  const preenchida = compacta.padStart(8, '0')
  const dia = Number(preenchida.slice(0, 2))
  const mes = Number(preenchida.slice(2, 4))
  const ano = Number(preenchida.slice(4))
  const data = new Date(Date.UTC(ano, mes - 1, dia))
  return dia >= 1 && dia <= 28 && data.getUTCDate() === dia
    && data.getUTCMonth() === mes - 1 && data.getUTCFullYear() === ano ? dia : null
}
